<template>
  <div class="is-padded-small has-text-justified">
    <b-taglist>
      <b-tag
        v-for="(observation, idx) in selectedObservations"
        :key=idx
        type="is-denim"
        closable
        size="is-medium"
        @close="deselectObservation(observation)"
      >
        {{ observation | capitalizeFirstLetter }}
      </b-tag>
    </b-taglist>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters(['selectedObservations'])
  },
  methods: {
    ...mapActions(['deselectObservation'])
  }
}
</script>

<style lang="scss">
  .tags::-webkit-scrollbar {
    display: none;
  }

  .tags {
    max-height: 150px;
    overflow: scroll;

    span {
      overflow: hidden;
    }
  }
</style>
